"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flightPassengerAppearing = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const actionLayout_1 = require("../../../../Table/columns/actionsColumn/actionLayout");
const views = {
    appear: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Actions:MarkAppeared', defaultMessage: 'Mark as appeared' })),
        iconName: 'checkmark-circle',
        iconModifiers: ['green'],
        targetOption: 'appear',
    },
    noShow: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Actions:MarkNoShow', defaultMessage: 'Mark as No-Show' })),
        iconName: 'minus-circle',
        iconModifiers: ['red'],
        targetOption: 'noShow',
    },
    pending: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Actions:MarkPending', defaultMessage: 'Mark as pending' })),
        iconName: 'x',
        targetOption: 'pending',
    },
};
exports.flightPassengerAppearing = (0, actionLayout_1.createActionLayout)([
    (state) => state === 'pending' ? views.appear : views.pending,
    (state) => state === 'pending' ? views.noShow : undefined,
]);
//# sourceMappingURL=flightPassengerAppearing.js.map